import React, { Component } from 'react';
import { bindActionCreators } from "redux";
import { connect } from 'react-redux';
import firebase from 'lib/firebase';
import ClipLoader from "react-spinners/ClipLoader";
import { Container, Col, Row } from 'react-bootstrap';
import moment from 'moment';
import axios from 'axios';
import BootstrapTable from 'react-bootstrap-table-next';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';

import * as AdminActions from 'store/modules/AdminModule';
import api from 'lib/api';
import global from 'lib/global';

import WorkbookFeedbackItem from './WorkbookFeedbackItem';
import Pagination from './Pagination';

class WorkbookScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {
            listSearchText: '',
            searchUser: null,
            isTabType: 0,
            visibleTutorMemo: false,

            //튜터메모관련
            userInfo: {},
            tutorMemoText: '',

            //피드백관련
            isExpanded: false,

            //페이지관련
            page: 0,
        }
    }


    componentDidMount() {
        this.props.adminActions.getAdminWorkbookList({
            page: 0,
            type: 0,
            user: 0,
        })
    }

    onClickGnb = (idx) => {
        this.props.onClickGnb(idx)
    }

    onRefreshList = () => {
        this.props.adminActions.getAdminWorkbookList({
            page: this.state.page,
            type: this.state.isTabType,
            user: 0,
        })
    }

    onChangePage = (pageIdx) => {
        this.props.adminActions.getAdminWorkbookList({
            page: pageIdx,
            type: this.state.isTabType,
            user: this.state.searchUser,
        })
        this.setState({ page: pageIdx })
    }

    onClickWorkbookBack = () => {
        this.props.adminActions.getAdminWorkbookList({
            page: this.state.page,
            type: this.state.isTabType,
            user: this.state.searchUser,
        })

        this.setState({ visibleTutorMemo: false })
    }

    onClickWorkbookTab = (tab) => {
        this.setState({
            isTabType: tab,
            visibleTutorMemo: false,
            page: 0,
            listSearchText:''
        })
        
        this.props.adminActions.getAdminWorkbookList({
            page: 0,
            type: tab,
            user: 0,
        })
    }

    onClickUser = async (idx) => {
        await this.props.adminActions.getAdminWorkbookList({
            page: 0,
            type: 4,
            user: idx,
        })

        let userInfo = this.props.adminWorkbookList.user_info;
        this.setState({
            visibleTutorMemo: true,
            searchUser: idx,
            userInfo: userInfo,
            tutorMemoText: userInfo.tutor_memo ? userInfo.tutor_memo : '',
        })
    }

    onChangeTutorMemo = (e) => {
        this.setState({ tutorMemoText: e.target.value })
    }

    uploadTutorMemo = async (e) => { //튜터메모 업로드
        let memo = this.state.tutorMemoText;
        let userIdx = this.props.adminWorkbookList.user_info.idx;
        this.props.adminActions.postAdminChangeTutorMemo({ userIdx: userIdx, userMemo: memo })
        this.props.adminActions.getAdminWorkbookList({
            page: 0,
            type: 4,
            user: userIdx,
        })
    }

    onChangeInputTutorSearch = (e) => {
        let searchInput = e.target.value;

        this.props.adminActions.getAdminWorkbookList({
            page: 0,
            type: 5,
            user: 0,
            search: searchInput
        })

        this.setState({
            listSearchText: searchInput,
            visibleTutorMemo: false
        });

        if (searchInput == "") {
            this.onRefreshList();
        }
    }

    tableCellIndexFormatter = (cell) => {
        return (
            <div onClick={() => this.onClickUser(cell)}>{cell}</div>
        )
    }

    tableCellDateFormatter = (cell) => {
        return (
            <div>{cell ? moment(cell).format('YYYY-MM-DD') : null}</div>
        )
    }

    tableCellFeedbackFormatter = (cell) => {
        return (
            <div>{cell ? '완료 : '+moment(cell).format('YYYY-MM-DD') : '대기'}</div>
        )
    }

    render() {
        // console.log('searchData: ', this.state.tutorMemoText)

        let countLevelAll = 0;
        let countLevel01 = 0;
        let countLevel02 = 0;
        if (this.props.adminWorkbookList) {
            countLevelAll = this.props.adminWorkbookList.all_count;
            countLevel01 = this.props.adminWorkbookList.level1_count;
            countLevel02 = this.props.adminWorkbookList.level2_count;
        }

        const workbookData = this.props.adminWorkbookList.list ? this.props.adminWorkbookList.list : [];

        workbookData.forEach(function (item, index) {
            let FileList = [];
            let files = item.files ? JSON.parse(item.files) : [];
            files.forEach(function (fileItem, index) {
                let layFile = (
                    <a href={fileItem} target="blank" key={index} style={{ marginRight: 10 }} >File{index + 1}</a>
                )
                FileList.push(layFile);
            })

            item['levelAndRound'] = item.level + '-' + item.round;
            item['fileList'] = FileList;
        })

        return (
            <div id='adminWorkbook'>
                <div id='workbookHeader'>
                    <Row>
                        <Col md={8}>
                            <ul>
                                <li className={'buttonTypeOff'}
                                    onClick={() => this.onClickWorkbookBack()}>back</li>
                                <li className={this.state.isTabType == 0 ? 'buttonTypeOn' : 'buttonTypeOff'} onClick={() => this.onClickWorkbookTab(0)}>All</li>
                                <li className={this.state.isTabType == 1 ? 'buttonTypeOn' : 'buttonTypeOff'} onClick={() => this.onClickWorkbookTab(1)}>Progress</li>
                                <li className={this.state.isTabType == 2 ? 'buttonTypeOn' : 'buttonTypeOff'} onClick={() => this.onClickWorkbookTab(2)}>Feedback</li>
                                <li className={this.state.isTabType == 3 ? 'buttonTypeOn' : 'buttonTypeOff'} onClick={() => this.onClickWorkbookTab(3)}>Complete</li>
                            </ul>
                        </Col>
                        <Col md={4}>
                            <ul>
                                <li>All:{countLevelAll}</li>
                                <li>Level 1:{countLevel01}</li>
                                <li>Level 2:{countLevel02}</li>
                            </ul>
                        </Col>
                    </Row>
                </div>

                <div id='body'>
                    <div id='functionContainer'>
                        <div id='adminSearch'>
                            <input
                                id='adminSearchInput'
                                type="text"
                                maxLength={30}
                                onChange={this.onChangeInputTutorSearch}
                                value={this.state.listSearchText}
                                placeholder={"Name, Email"} />
                            <img src={"/write/icon_search.png"} alt="search" />
                        </div>
                        {/* 페이지 */}
                        <Pagination
                            maxPage={this.props.adminWorkbookList.page_all ? this.props.adminWorkbookList.page_all : 0}
                            isPage={this.state.page}
                            onPagination={this.onChangePage} />
                    </div>



                    {/* 튜터 메모 */}
                    {this.state.visibleTutorMemo ?
                        <div id='tutorMemo'>
                            <Row>
                                <Col md={10}>
                                    <p>{this.state.userInfo.nick_name} ( {this.state.userInfo.email} )</p>
                                    <textarea
                                        id="tutorMemoTextarea"
                                        value={this.state.tutorMemoText}
                                        onChange={(e) => this.onChangeTutorMemo(e)} />
                                </Col>
                                <Col md={2} className="my-auto" style={{ textAlign: "center" }}>
                                    <a className='buttonSave' onClick={(e) => this.uploadTutorMemo(e)}
                                        style={this.state.userInfo.tutor_memo != this.state.tutorMemoText ? { backgroundColor: '#ffcf87' } : { backgroundColor: '#ccc' }}
                                    >Save</a>
                                </Col>
                            </Row>
                        </div>
                        : null}

                    <div id='table'>
                        <BootstrapTable
                            keyField='idx'
                            classes='table'
                            headerWrapperClasses='tableHeader'
                            bodyClasses='tableBody'
                            bordered={true}
                            data={workbookData}
                            rowStyle={{cursor:'pointer'}}
                            columns={[
                                {
                                    dataField: 'idx', text: 'No',
                                    headerClasses: 'table_width60', classes: 'table_width60',
                                    formatter: this.tableCellIndexFormatter
                                },
                                {
                                    dataField: 'nick_name', text: 'Name',
                                    headerClasses: 'table_width200', classes: 'table_width200'
                                },
                                {
                                    dataField: 'levelAndRound', text: 'Lv-Ro',
                                    headerClasses: 'table_width100', classes: 'table_width100'
                                },
                                {
                                    dataField: 'send_date', text: 'Date(send)',
                                    headerClasses: 'table_width150', classes: 'table_width150',
                                    formatter: this.tableCellDateFormatter
                                },
                                {
                                    dataField: 'get_date', text: 'Date(submit)',
                                    headerClasses: 'table_width150', classes: 'table_width150',
                                    formatter: this.tableCellDateFormatter
                                },
                                {
                                    dataField: 'fileList', text: 'Files', style: { color: '#6f9bec' }
                                },
                                {
                                    dataField: 'edit_date', text: 'Feedback',
                                    headerClasses: 'table_width150', classes: 'table_width150',
                                    formatter: this.tableCellFeedbackFormatter
                                },
                            ]}
                            // rowEvents={{
                            //     onClick: (e, row, rowIndex) => this.onClickUser(e, row, rowIndex),
                            // }}
                            expandRow={{
                                onlyOneExpanding: true,
                                className: 'tableExpandRow',
                                renderer: (row, rowIndex) => (
                                    <WorkbookFeedbackItem item={row} index={rowIndex}
                                        onRefreshList={this.onRefreshList} />
                                )
                            }} />
                    </div>
                </div>
            </div>
        );
    }
}



let mapStateToProps = (state) => ({
    adminWorkbookList: JSON.parse(JSON.stringify(state.AdminModule.get('adminWorkbookList'))),
});

let mapDispatchToProps = (dispatch) => ({
    adminActions: bindActionCreators(AdminActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(WorkbookScreen);

